export const SUPPORTED_DOC_LIST_URLS = {
  au: "https://assets.latitudefinancial.com/proof-of-income/POI-Verification-Table.pdf",
  nz: "https://www.gemfinance.co.nz/supporting-documents/?tlga=545625902.1710975403&adobe_mc=MCMID%3D25144401797892332934878655815595202882%7CMCORGID%3DB6D9B74F57B2FBE97F000101%2540AdobeOrg%7CTS%3D1731911903"
}
